const PROJECT_NON_FOLDER_TAB_SEGMENTS = ["playbooks", "reviews", "workflows", "changes", "tasks"];

/** These tabs own the whole project scope, so they don't want folder scope injected into the URL.
 *  Keep in sync with the non-"folders" keys in PROJECT_TABS (ProjectTabsNav.tsx). */
export function isProjectNonFolderTabPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return new RegExp(`/files/projects/[^/]+/(${PROJECT_NON_FOLDER_TAB_SEGMENTS.join("|")})(/|$)`).test(pathname);
}
